import { createFileRoute } from "@tanstack/react-router";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Activity } from "lucide-react";

export const Route = createFileRoute("/integration/observations")({
  component: ObservationsLive,
});

function ObservationsLive() {
  return (
    <div className="space-y-4 p-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold tracking-tight flex items-center gap-2">
            <Activity className="h-5 w-5" /> Observations temps réel
          </h1>
          <p className="mt-1 text-sm text-muted-foreground">Signes vitaux · Scopes monitorés · Alertes</p>
        </div>
        <Badge variant="destructive" className="animate-pulse">LIVE</Badge>
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Stream d'observations</CardTitle>
          <CardDescription>HL7 FHIR Observation · WebSocket</CardDescription>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          Connexion temps réel aux moniteurs et dispositifs IoMT.
        </CardContent>
      </Card>
    </div>
  );
}
